import Surveys from './SurveysContainer';

export default Surveys;
